import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import { Search } from "@material-ui/icons"
import { useContext, useEffect, useMemo, useState } from "react"
import { useQuery } from "react-query"
import { useHistory } from "react-router-dom"
import { listCourses } from "~/actions/courses"
import AddedCourseCard from "~/components/Clients/AddedCourseCard"
import LoaderButton from "~/components/LoaderButton/index.jsx"
import AppContext from "~/contexts/App"
import ClientContext from "~/contexts/Client"

import Box from "~/components/Common/Box"
import useStyles from "./styles"

const AddCourseToClient = () => {
  const classes = useStyles()
  const theme = useTheme()
  const history = useHistory()
  const { dialogs, closeDialog, openSnackBar, authUser } =
    useContext(AppContext)
  const thisDialog = dialogs?.["addCourseToDialog"] || {}
  const { open = false, data } = thisDialog

  const { data: allCourses } = useQuery("courses", () => listCourses(), {
    enabled: !!authUser,
  })

  const { courseArray, setCourseArray } = useContext(ClientContext)
  const [searchValue, setSearchValue] = useState("")
  const [addedCourses, setAddedCourses] = useState([])
  const smDown = useMediaQuery(theme.breakpoints.down("sm"))

  //close dialog set search value to empty string and
  //set component array state to the context state
  const handleClose = () => {
    closeDialog("addCourseToDialog", false)
    setSearchValue("")
    setAddedCourses(courseArray)
  }

  //open Lesson dialog
  const openCourses = () => {
    history.push("/courses")
    handleClose()
  }

  //close the dialog
  const addCourse = () => {
    setCourseArray(addedCourses)
    handleClose()
  }

  ///set course array in context to a component state to only replace the context array
  useEffect(() => {
    setAddedCourses(courseArray)
  }, [courseArray])

  const filteredCourses = useMemo(() => {
    if (!allCourses) {
      return []
    }
    const containerCourses = {}
    allCourses.forEach((course) => {
      if (containerCourses[course.container_id]) {
        const oldVersion = containerCourses[course.container_id].version
        if (
          oldVersion.localeCompare(course.version, undefined, {
            numeric: true,
            sensitivity: "base",
          }) < 0
        ) {
          containerCourses[course.container_id] = course
        }
      } else {
        containerCourses[course.container_id] = course
      }
    })

    const uniqueCourses = Object.values(containerCourses)

    uniqueCourses.sort((a, b) =>
      a.published === b.published
        ? a.name.localeCompare(b.name)
        : b.published - a.published,
    )

    if (searchValue.length > 0) {
      return uniqueCourses.filter((course) => {
        return course?.versions[0].name
          .toLowerCase()
          .includes(searchValue.toLowerCase())
      })
    }
    return uniqueCourses
  }, [allCourses, searchValue])

  return (
    <Dialog
      classes={{ paperWidthSm: classes.dialogContainer }}
      open={open}
      fullScreen={smDown}
    >
      <DialogTitle className={classes.dialogTitle}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          className={classes.dialogTop}
        >
          <Typography variant="h2" className={classes.title}>
            Add Course
          </Typography>
          <TextField
            placeholder="Search courses"
            className={classes.search}
            onChange={(e) => setSearchValue(e.target.value)}
            InputProps={{
              disableUnderline: true,
              startAdornment: (
                <InputAdornment position="start" style={{ marginLeft: "10px" }}>
                  <Search className={classes.searchIcon} />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        {!allCourses ? (
          <CircularProgress />
        ) : (
          filteredCourses?.map((course) => {
            return (
              <AddedCourseCard
                course={course}
                key={course.id}
                addedCourses={addedCourses}
                setAddedCourses={setAddedCourses}
                showVersion={false}
              />
            )
          })
        )}
      </DialogContent>
      <DialogActions
        style={{
          position: "absolute",
          bottom: 4,
          width: "100%",
        }}
        className={classes.actions}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          width="100%"
          marginLeft="20px"
          marginRight="20px"
          className={classes.actionBox}
        >
          <Box>
            <Button className={classes.remove} onClick={openCourses}>
              Create Course
            </Button>
          </Box>
          <Box>
            <Button
              onClick={handleClose}
              style={{ height: "40px", marginRight: "10px" }}
            >
              Cancel
            </Button>
            <LoaderButton
              onClick={addCourse}
              classoverrides={{
                wrapper: classes.button,
                button: {
                  root: classes.buttonRoot,
                },
              }}
              variant="contained"
              color="secondary"
              size="small"
            >
              add
            </LoaderButton>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

AddCourseToClient.propTypes = {}

export default AddCourseToClient
